// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__ZwuDV","spinner":"loader_spinner__a3oZp","s3":"loader_s3__Uk-lM"};